import Vue from 'vue'
import Vuex from 'vuex'
import VueLocalStorage from 'vue-localstorage'

import config from '@/config'

import actions from './actions'
import getters from './getters'
import mutations from './mutations'

Vue.use(Vuex)
Vue.use(VueLocalStorage)

export const store = new Vuex.Store({
  state: {
    socialChannelOptions: [
      {
        value: 'fb',
        text: 'Facebook',
        icon: 'fab fa-facebook'
      },
      { value: 'line', text: 'Line', icon: 'fab fa-line' },
      {
        value: 'ig',
        text: 'Instagram',
        icon: 'fab fa-instagram'
      }
    ],
    botStatus: false,
    loading: false,
    isLoggedIn: !!Vue.localStorage.get('token'),
    isFacebook: Vue.localStorage.get('FB') === 'true',
    isSelectedBot: !!Vue.localStorage.get('selectedBot'),
    selectedBot:
      Vue.localStorage.get('selectedBot') && Vue.localStorage.get('selectedBot') !== 'undefined'
        ? JSON.parse(Vue.localStorage.get('selectedBot'))
        : [],
    userid: Vue.localStorage.get('userid'),
    botlist:
      Vue.localStorage.get('botlist') && Vue.localStorage.get('botlist') !== 'undefined'
        ? JSON.parse(Vue.localStorage.get('botlist'))
        : [],
    pagelist:
      Vue.localStorage.get('pagelist') && Vue.localStorage.get('pagelist') !== 'undefined'
        ? JSON.parse(Vue.localStorage.get('pagelist'))
        : [],
    accessToken: Vue.localStorage.get('token'),
    fbAccessToken: Vue.localStorage.get('fbtoken'),
    openSidebar: true,
    paypalTrackingId: Vue.localStorage.get('paypalTrackingId'),
    setting: undefined,
    welcomeMessage: undefined,
    showModalWelcome: Vue.localStorage.get('showModalWelcome'),
    theme: config.theme,
    chatbot: {
      intentGroup: undefined
    },
    loginChannel: ['facebook', 'account', 'chat2pay'].includes(Vue.localStorage.get('loginChannel'))
      ? Vue.localStorage.get('loginChannel')
      : 'facebook',
    fbScope: Vue.localStorage.get('fbScope'),
    tutoriallist: [],
    alert:
      Vue.localStorage.get('alerts') && Vue.localStorage.get('alerts') !== 'undefined'
        ? JSON.parse(Vue.localStorage.get('alerts'))
        : [],
    pageBU: ['114743896611281', '132880665271'],
    specialpage: [
      '619202881423565',
      '2261615673888062',
      '1231805606976542',
      '1493632560856869',
      '2105726733070683',
      '391365474996527',
      '282419538600861',
      '229446640739626',
      '229777340553912',
      '1422119811377985',
      '1441887002726565',
      '367229174088451',
      '2244102365841101'
    ],
    astonpages: [
      '998122266996445',
      '2261615673888062',
      '1231805606976542',
      '1493632560856869',
      '2105726733070683',
      '391365474996527',
      '282419538600861',
      '229446640739626',
      '229777340553912',
      '1422119811377985',
      '1441887002726565',
      '367229174088451',
      '2244102365841101',
      '701617826905112',
      '1610279989092091',
      '188902974930963',
      '638403099982540',
      '104681644249934',
      '251931082395852',
      //----------------- Aston Line
      '115245059851835',
      '103782414379044',
      '104620487627501',
      '110883070374655',
      '101788984628392',
      '114106830003988'
    ],
    linenotifylist: [],
    ecommerce: {
      products: [],
      loadingProduct: true,
      categories: [],
      loadingCategory: true,
      charges: {},
      loadingCharges: true
    },
    loadingUserStatus: true,
    userStatus: [],
    loadingSetting: true,
    livechatPageList: [],
    livechatPageIdList: [],
    livechat: {
      app: 'facebook',
      userlist: {
        admin: {
          offset: 0,
          loading: false,
          limit: 20,
          users: [],
          isAutoRefresh: true,
          hasMore: true,
          hasNew: false
        },
        bot: {
          offset: 0,
          loading: false,
          limit: 20,
          users: [],
          isAutoRefresh: true,
          hasMore: true,
          hasNew: false
        }
      },
      currentUser: null,
      chatlog: [],
      loadingChatlog: true,
      limitFatchChatlog: 20,
      maxFatchChatlogTime: 15000, // 15 sec
      limitFatchUser: 20,
      maxFatchUserTime: 15000 // 15 sec
    },
    modal: {
      input: {},
      component: null,
      open: false,
      width: '600px'
    },
    allSchools: [],

    intents: undefined,
    loadingIntents: true
  },
  getters,
  mutations,
  actions
})



// WEBPACK FOOTER //
// ./src/store/store.js